'use strict'

import format from 'string-format'
import AmpliVarStatApi from "../api";

import {Analysis} from '../models'

const ANALYSIS_LIST_SET = 'ANALYSIS_LIST_SET'
const ANALYSIS_CREATE = 'ANALYSIS_CREATE'
const ANALYSIS_UPDATE = 'ANALYSIS_UPDATE'

const initialState = {
	analysis_list: [],
	analyzes: {},
}

export default class {
	constructor(subsite) {
		this._subsite = subsite

		this.namespaced = true
		this.state = initialState

		this._api = new AmpliVarStatApi(this._subsite)

		this.actions = {

			analysis_list: ({commit, rootState}) => {
				return this._api.analysis_list()
					.then((response) => {
						const obj_list = Array.from(
							response.data,
							(a) => new Analysis(a, rootState))

						commit(ANALYSIS_LIST_SET, obj_list)
					})
					.catch((error) => {
						commit(ANALYSIS_LIST_SET, [])
						throw error
					})
			},

			analysis_create: ({commit, rootState}, {analysis, details = true}) => {
				return this._api.analysis_create(analysis, details)
					.then((response) => {
						const obj = new Analysis(response.data, rootState)
						commit(ANALYSIS_CREATE, obj)
					})
			},

			analysis_update: ({commit, rootState}, {analysis, details = true}) => {
				return this._api.analysis_update(analysis, details)
					.then((response) => {
						const obj = new Analysis(response.data, rootState)
						commit(ANALYSIS_UPDATE, obj)
					})
			},

			analysis_run: ({commit}, {analysis_id}) => {
				return this._api.analysis_run(analysis_id)
					.then((response) => {
						// состояние анализа поменяется вероятно
						// здесь может придти индентификатор задачи
						commit(ANALYSIS_UPDATE, response.data)
					})
			},
		}
	}

	mutations = {
		[ANALYSIS_LIST_SET](state, data_list) {
			state.analysis_list = data_list
			state.analyzes = Object.assign({}, ...data_list.map((a) => ({[a.id]: a})))
		},

		[ANALYSIS_CREATE](state, obj) {
			state.analyzes[obj.id] = obj
			state.analysis_list.push(obj)
		},

		/**
		 * Чтобы не заменять объект в списках
		 * state.analises_list и state.analyzes
		 * обновим значения полей в существующем объекте
		 */
		[ANALYSIS_UPDATE](state, obj) {
			const tgt = state.analyzes[obj.id]
			for (let key in tgt) {
				tgt[key] = obj[key]
			}
		},

	}

	getters = {
		analysis_list(state) {
			return state.analysis_list
		},

		analyzes(state) {
			return state.analyzes
		},
	}
}